import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/**
 * Decentni info text (fine print) na verejne strance s vysledky — beta / zkusebni provoz.
 * Always-on, text natvrdo; po vyjiti z bety komponentu smazat.
 */
export const PublicTrialNotice = () => {
  return (
    <Box
      sx={{
        mt: 3,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        gap: 0.75,
      }}
    >
      <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.disabled', mt: '2px', flexShrink: 0 }} />
      <Typography
        variant="caption"
        sx={{ color: 'text.secondary', textAlign: 'center', maxWidth: 560, lineHeight: 1.5 }}
      >
        Systém je v beta verzi a průběžně se vyvíjí. Oficiálně platí vždy výsledková listina, kterou
        eviduje pořadatel na papíře.
      </Typography>
    </Box>
  );
};
